import { createSlice } from '@reduxjs/toolkit';
import { AxiosResponseModel } from '../../@types/base';
import { CONSTS } from './const';
import { dispatch } from '../store';
import axios from '../../utils/axios';
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';
import {
  EntityCountListModel,
  EntityCountModel,
  DailyEntityCountModel
} from '../../@types/entity-count';
import { cameraBetweenDatesDetailInit } from './camera';

// ----------------------------------------------------------------------

type EntityCountState = {
  entityCountListError: boolean;
  isEntityCountListLoading: boolean;
  entityCountList: EntityCountListModel[];

  entityList: EntityCountModel;
  createEntityCountListModalIsOpen: boolean;
  updateEntityCountListModalIsOpen: boolean;

  entityCountError: boolean;
  isEntityCountLoading: boolean;

  createEntityCountModalIsOpen: boolean;
  updateEntityCountModalIsOpen: boolean;

  dailyEntityCountError: boolean;
  isDailyEntityCountLoading: boolean;
  dailyEntityCount: DailyEntityCountModel[];

  createDailyEntityCountModalIsOpen: boolean;
  updateDailyEntityCountModalIsOpen: boolean;
};

const alarmAndWarningListInit: EntityCountListModel = {
  id: 0,
  in: 0,
  out: 0,
  total: 0,
  cameraId:"",
  entity: "",
  timestamp: "",
  companyId: 0,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  camera: cameraBetweenDatesDetailInit,
};


const initialState: EntityCountState = {
  entityCountListError: false,
  isEntityCountListLoading: false,
  entityCountList: [],
  entityList: alarmAndWarningListInit,

  createEntityCountListModalIsOpen: false,
  updateEntityCountListModalIsOpen: false,

  entityCountError: false,
  isEntityCountLoading: false,

  dailyEntityCountError: false,
  isDailyEntityCountLoading: false,
  dailyEntityCount: [],

  createDailyEntityCountModalIsOpen: false,
  updateDailyEntityCountModalIsOpen: false,

  createEntityCountModalIsOpen: false,
  updateEntityCountModalIsOpen: false,

};

const slice = createSlice({
  name: 'entityCount',
  initialState,
  reducers: {
    // ----------------------------------------------------------------------
    // ALERT AND WARNING LIST
    // ----------------------------------------------------------------------

    // START ALERT AND WARNING LIST LOADING
    startEntityCountListLoading(state) {
      state.isEntityCountListLoading = true;
    },

    stopEntityCountListLoading(state) {
      state.isEntityCountListLoading = false;
    },

    // HAS ERROR ALERT AND WARNING LIST
    hasErrorEntityCountList(state, action) {
      state.isEntityCountListLoading = false;
      state.entityCountListError = action.payload;
    },

    // GET ALERT AND WARNING LIST
    getEntityCountListSuccess(state, action) {
      state.isEntityCountListLoading = false;
      state.entityCountList = action.payload;
    },

    startEntityCountLoading(state) {
      state.isEntityCountLoading = true;
    },

    hasErrorEntityCount(state, action) {
      state.isEntityCountLoading = false;
      state.entityCountError = action.payload;
    },


    startDailyEntityCountLoading(state) {
      state.isDailyEntityCountLoading = true;
    },


    getDailyEntityCountSuccess(state, action) {
      state.isDailyEntityCountLoading = false;
      state.dailyEntityCount = action.payload;
    },
  }
});

// Reducer
export default slice.reducer;

// Actions
// export const {} = slice.actions;

// ----------------------------------------------------------------------
// ALERT AND WARNING

export async function getAllEntityCountsWithReturn(
  startDate: string,
  endDate: string,
) {
  dispatch(slice.actions.startEntityCountListLoading());
  try {

    if (startDate.includes('T')) {
      startDate = startDate.slice(0, startDate.indexOf('T'));
    }
    if (endDate.includes('T')) {
      endDate = endDate.slice(0, endDate.indexOf('T'));
    }
    const requestURL = `${CONSTS.ENTITY_COUNT_GET_ALL}?startDate=${startDate}&endDate=${endDate}`;

    const response: AxiosResponseModel<EntityCountListModel> = await axios
      .get(requestURL)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.getEntityCountListSuccess(response.data?.data));
      // console.log(alarmAndWarningListInıt.total);
      // dispatch(slice.actions.getAllAlarmAndWarningListSuccess([]));
      // dispatch(
      //   slice.actions.getAllAlarmAndWarningListSuccess(response.data?.data)
      // );
    }
    // } else {
    //   dispatch(slice.actions.getAllAlarmAndWarningListSuccess([]));
    // }
    // return response;
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEntityCountList(error));
    return error.response.data;
  }
}

export async function getDailyEntityCountWithReturn(
  startDate: string,
  endDate: string
) {
  dispatch(slice.actions.startDailyEntityCountLoading());
  try {
    if (startDate.includes('T')) {
      startDate = startDate.slice(0, startDate.indexOf('T'));
    }
    if (endDate.includes('T')) {
      endDate = endDate.slice(0, endDate.indexOf('T'));
    }
    const requestURL = `${CONSTS.ENTITY_COUNT_GET_DAILY}?startDate=${startDate}&endDate=${endDate}`;
    const response: AxiosResponseModel<DailyEntityCountModel> = await axios
      .get(requestURL)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.getDailyEntityCountSuccess(response.data?.data)
      );
    } else {
      dispatch(slice.actions.getDailyEntityCountSuccess([]));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorEntityCount(error));
    return error.response.data;
  }
}

// ----------------------------------------------------------------------
